// extracted by mini-css-extract-plugin
module.exports = {"Badge":"SyncListItemStatusBadge_Badge__2UiRK"};